var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-main"},[_c('InnerHeader',{attrs:{"cover":require('../../assets/img/about/cover.jpg'),"bgColor":'#164194',"bgPosition":'0 60%',"links":_vm.links}}),(!_vm.$route.query.page)?_c('About'):(_vm.$route.query.page === 'history')?_c('History'):(_vm.$route.query.page === 'mission')?_c('Mission'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }